<template>
  <md-layout md-align="center">
    <md-layout md-row>
      <md-layout md-column>
        <form @submit.stop.prevent="login">
          <md-card class="login-card">
            <!-- <md-card-media>
              <img src="../assets/blh_logo.jpg" />
            </md-card-media> -->
            <md-card-header>
              <div class="md-title">CERTIFICAÇÃO DAS INSTALAÇÕES E EQUIPAMENTOS DO BLH</div>
              <div class="md-subhead">Insira suas credenciais</div>
            </md-card-header>
            <md-card-content>
              <md-input-container>
                <label>Email</label>
                <md-input
                  v-model.trim="credentials.email"
                  required
                  placeholder="Digite seu email"
                ></md-input>
                <span class="md-error">Email obrigatório</span>
              </md-input-container>
              <md-input-container>
                <label>Senha</label>
                <md-input
                  v-model.trim="credentials.password"
                  required
                  type="password"
                  placeholder="Digite sua senha"
                ></md-input>
                <span class="md-error">Senha obrigatória</span>
              </md-input-container>
              <md-card-actions>
                <!-- <md-button>Esqueci minha senha</md-button> -->
                <md-button
                  type="submit"
                  class="md-raised md-primary"
                >Entrar</md-button>
              </md-card-actions>
            </md-card-content>
            <md-snackbar
              md-position="bottom center"
              ref="snackbar"
              md-duration="4000"
            >
              <span>{{erro}}</span>
              <md-button
                class="md-accent"
                md-theme="light-blue"
                @click="$refs.snackbar.close()"
              >FECHAR</md-button>
            </md-snackbar>
          </md-card>
        </form>
      </md-layout>
    </md-layout>
  </md-layout>
</template>
<style>
.login-card {
  max-width: 360px;
  margin: 5% auto;
  display: block;
}

.logo-blh {
  display: block;
  max-width: 300px;
  max-height: 300px;
  width: auto;
  height: auto;
}
</style>
<script>
export default {
  name: 'login',
  data () {
    return {
      credentials: {
        email: '',
        password: ''
      },
      erro: ''
    }
  },
  methods: {
    login () {
      var vm = this
      vm.$store.dispatch('LOGIN', vm.credentials).then(uid => {
        console.log('user authenticated')
        vm.$router.push('home')
      }).catch(error => {
        var errorCode = error.code
        var errorMessage = error.message
        switch (errorCode.toString()) {
          case 'auth/user-not-found':
            errorMessage = 'Usuário não encontrado'
            break
          case 'auth/invalid-email':
            errorMessage = 'Email Inválido'
            break
          case 'auth/wrong-password':
            errorMessage = 'Senha Inválida'
            break
          case 'auth/network-request-failed':
            errorMessage = 'Ocorreu um erro de rede, verifique se você está conectado à internet'
            break
          case '101':
            errorMessage = 'Usuário/Senha Inválidos'
        }

        vm.erro = `${errorMessage} (${errorCode})`
        vm.$refs.snackbar.open()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// LoginView.vue?a5ef08e6